import { Tour } from '../types';

export const browseIntroTour: Tour = {
  id: 'browse-intro',
  name: 'Browse Page Tour',
  trigger: 'first-page-visit',
  priority: 5,
  pathname: '/browse',
  steps: [
    {
      id: 'browse-search',
      targetSelector: 'browse-search',
      title: 'Search Scholarships',
      description:
        'Type keywords to instantly filter scholarships by name, organization, or category.',
      placement: 'bottom',
    },
    {
      id: 'browse-filters',
      targetSelector: 'browse-filters',
      title: 'Filter & Sort',
      description:
        'Narrow results by category, amount, deadline, and more. Toggle between grid and list views.',
      placement: 'bottom',
    },
    {
      id: 'browse-card',
      targetSelector: 'browse-card-first',
      title: 'Scholarship Cards',
      description:
        'Each card shows match score, amount, and deadline. Click to see full details and apply.',
      placement: 'right',
    },
  ],
};

export const journeyTodayIntroTour: Tour = {
  id: 'journey-today-intro',
  name: 'Today View Tour',
  trigger: 'first-page-visit',
  priority: 5,
  pathname: '/my-scholarships',
  steps: [
    {
      id: 'today-hero',
      targetSelector: 'today-hero-action',
      title: 'Your Top Priority',
      description:
        'This is the scholarship that needs your attention most right now — based on deadline urgency and how far along you are.',
      placement: 'bottom',
    },
    {
      id: 'today-checklist',
      targetSelector: 'today-hero-tasks',
      title: 'Pick Any Task',
      description:
        'These are the tasks left on your checklist. You can tackle them in any order — just tap one to check it off.',
      placement: 'top',
    },
    {
      id: 'today-queue',
      targetSelector: 'today-action-queue',
      title: 'Up Next',
      description:
        'Your other active scholarships are listed here by priority. Click any card for full details.',
      placement: 'top',
    },
    {
      id: 'today-view-toggle',
      targetSelector: 'journey-view-toggle',
      title: 'Switch Views',
      description:
        'Toggle between Today (focused action list) and Tracker (drag-and-drop board) any time.',
      placement: 'bottom',
    },
  ],
};

export const journeyTrackerIntroTour: Tour = {
  id: 'journey-tracker-intro',
  name: 'Tracker View Tour',
  trigger: 'first-page-visit',
  priority: 5,
  pathname: '/my-scholarships',
  steps: [
    {
      id: 'journey-kanban',
      targetSelector: 'journey-kanban',
      title: 'Your Scholarship Board',
      description:
        'Track every application across four stages: Saved, In Progress, Applied, and Heard Back.',
      placement: 'top',
    },
    {
      id: 'journey-drag',
      targetSelector: 'journey-card-first',
      title: 'Drag to Move Cards',
      description:
        'Drag cards between columns to update their status, or use the buttons at the bottom of each card. Save scholarships from Browse to get started!',
      placement: 'right',
    },
    {
      id: 'tracker-view-toggle',
      targetSelector: 'journey-view-toggle',
      title: 'Switch Views',
      description:
        'Switch to Today view for a focused, prioritized action list that tells you exactly what to work on next.',
      placement: 'bottom',
    },
  ],
};

// Legacy alias — keeps existing "journey-intro" completed progress working
export const journeyIntroTour = journeyTrackerIntroTour;

export const essaysIntroTour: Tour = {
  id: 'essays-intro',
  name: 'Essays Page Tour',
  trigger: 'first-page-visit',
  priority: 5,
  pathname: '/essays',
  steps: [
    {
      id: 'essays-templates',
      targetSelector: 'essays-templates',
      title: 'Essay Templates',
      description:
        'Start with proven frameworks for common scholarship essay prompts.',
      placement: 'bottom',
    },
    {
      id: 'essays-examples',
      targetSelector: 'essays-examples',
      title: 'Example Essays',
      description:
        'Read annotated winning essays to learn what makes a great submission.',
      placement: 'bottom',
    },
  ],
};

export const pageTours = [browseIntroTour, journeyTodayIntroTour, journeyTrackerIntroTour, essaysIntroTour];
